export const environment = {
  production: true,
  useMockServer: false
};
